module.exports = __webpack_public_path__ + "static/media/imageForTopProducts.781c05db.png";